import React, { useEffect } from 'react'
import {
  useParams,
  useNavigate
} from "react-router-dom";
import { Resource, useStore } from 'react-admin';
import { GetsubscriberinboxList } from '../../componets/Ats/GetsubscriberinboxList';
import ApplicantDetailEdit from '../../componets/Ats/ApplicantDetailEdit';
import { GetAdmininboxList } from '../../componets/Ats/GetAdmininboxList';
import { GetAdminSubcriberList } from '../../componets/Ats/GetAdminSubcriberList';

export default function SubscriberAdminUsage() {
  return (
    <Resource name='getsubscriberusage' list={<GetAdminSubcriberList/>} />
  )
}
